import { render, staticRenderFns } from "./BackendErrorPage.vue?vue&type=template&id=5adf9331&scoped=true&"
import script from "./BackendErrorPage.vue?vue&type=script&lang=js&"
export * from "./BackendErrorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adf9331",
  null
  
)

export default component.exports